// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XzBN","name":"styles_name__3BBuY","phone":"styles_phone__3s-By"};